import { TableService } from './table-service';
import { Commodity } from '../../../models/commodity';
import { CommodityQuery } from '../../../models/commodity-query';
import { Observable, of } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectCommodityTableBusy, selectCommodityTableCount, selectCommodityTableDeleting,
    selectCommodityTablePage,
    selectCommodityTableQuery,
    selectCommodityTableSelection
} from '../../../store/commodity-table/commodity-table.state';
import { CommodityColumnEnum } from '../../../enum/commodity-column.enum';
import {
    commodityTableChangePage,
    commodityTableMasterToggle,
    commodityTableSort,
    commodityTableToggle
} from '../../../store/commodity-table/commodity-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class CommoditiesTableService extends TableService<Commodity, CommodityQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectCommodityTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            CommodityColumnEnum.COMMODITY_DESCRIPTION,
            CommodityColumnEnum.COMMODITY_WEIGHT,
            CommodityColumnEnum.COMMODITY_HS_CODE,
            CommodityColumnEnum.COMMODITY_VALUE,
            CommodityColumnEnum.COMMODITY_COUNTRY,
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Commodity[]> {
        return this.store.select(selectCommodityTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.COMMODITY;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectCommodityTableSelection);
    }

    protected getTableQueryObservable(): Observable<CommodityQuery> {
        return this.store.select(selectCommodityTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectCommodityTableCount);
    }

    protected getLockedObservable(): Observable<string[]> {
        return this.store.select(selectCommodityTableDeleting);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(commodityTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(commodityTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(commodityTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(commodityTableMasterToggle());
    }

    protected getWidthBufferPx(): number {
        return super.getWidthBufferPx() + 100;
    }

}
